var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinetask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 158 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7{fill:none;stroke-miterlimit:10;}.cls-1{stroke:url(#Degradado_sin_nombre_4);}.cls-2,.cls-6{stroke-dasharray:3.01 3.01;}.cls-2{stroke:url(#Degradado_sin_nombre_4-2);}.cls-3{stroke:url(#Degradado_sin_nombre_4-3);}.cls-4{fill:url(#Degradado_sin_nombre_257);}.cls-5{stroke:url(#Degradado_sin_nombre_4-4);}.cls-6{stroke:url(#Degradado_sin_nombre_4-5);}.cls-7{stroke:url(#Degradado_sin_nombre_4-6);}.cls-8{fill:url(#Degradado_sin_nombre_257-2);}.cls-9{fill:url(#Degradado_sin_nombre_257-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 1,
    y1: 116.74,
    x2: 144.4,
    y2: 116.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#debdc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16e6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: 1,
    y1: 58.32,
    x2: 144.4,
    y2: 58.32,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-3",
    x1: 1,
    y1: 1.21,
    x2: 144.4,
    y2: 1.21,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_257",
    x1: 74,
    y1: 65,
    x2: 96,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#debdc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#16e6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#13e2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0ad8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04d094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-4",
    x1: 28.05,
    y1: 145.31,
    x2: 40.03,
    y2: 2.41,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-5",
    x1: 86.26,
    y1: 150.19,
    x2: 98.25,
    y2: 7.29,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-6",
    x1: 143.18,
    y1: 154.97,
    x2: 155.16,
    y2: 12.07,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_257-2",
    x1: 36,
    y1: 139,
    x2: 48,
    y2: 139,
    xlinkHref: "#Degradado_sin_nombre_257"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_257-3",
    x1: 123,
    y1: 12,
    x2: 135,
    y2: 12,
    xlinkHref: "#Degradado_sin_nombre_257"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,117.5A14.83,14.83,0,0,1,1.78,116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.6,113.14c3.66-11,19-39.42,79.9-46.64,65.6-7.77,62.66-51.3,60.62-63.07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.84,2C142.64,1,142.5.5,142.5.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 85,
    cy: 65,
    r: 11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.34,144.75a13.23,13.23,0,0,0,1.48-.15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.77,144C43,141.29,72.64,128.43,84.93,68.3c13.22-64.72,56.35-58.15,67.91-55.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.29,13.56c.92.28,1.42.46,1.42.46"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 42,
    cy: 139,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 129,
    cy: 12,
    r: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinetask);
export default __webpack_public_path__ + "static/media/linetask.d2685016a306ac21f364ec2f94e024ea.svg";
export { ForwardRef as ReactComponent };